export const payPeriodsQueryKeys = {
  all: (queryParams = {}) => ['fetch_all_payPeriods', queryParams] as const,
  one: (pay_period_id: number) => ['fetch_pay_period', pay_period_id],
  create: () => ['create_pay_period'],
  bulkUpdate: () => ['bulk_update_pay_periods'],
  delete: () => ['delete_pay_period']
}
